import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { DirectoryTopperEntry } from "frontend/contentful/schema/toppers";
import { DirectoryTopperProps } from "design-system/sites/alumni/directory-topper/directory-topper";
import {
  DirectorySearchFilterGroup,
  DirectorySearchProps,
} from "design-system/sites/alumni/directory-topper/directory-search";
import { useFetch } from "frontend/hooks/use-fetch";
import { Option } from "design-system/components/primitives/checkbox-filter-list/checkbox-filter-list-option";

export const createDirectoryTopperProps = createContentfulProps<
  DirectoryTopperEntry,
  DirectoryTopperProps
>(({ entry }) => {
  const facets = [
    {
      group: "Employment",
      label: "Current Company",
      id: "currentOrganizationName",
      featured: true,
    },
    { group: "Personal", label: "Interests", id: "interest", featured: true },
    { group: "Employment", label: "Industry", id: "industry", featured: true },
    {
      group: "Personal",
      label: "Home Country",
      id: "homeCountrySorted",
      featured: true,
    },
    {
      group: "Education",
      label: "HBS Degree/Program",
      id: "degreeCode",
      featured: false,
    },
    {
      group: "Education",
      label: "Harvard University",
      id: "nonHBSDegreeCode",
      featured: false,
    },
    {
      group: "Education",
      label: "College",
      id: "nonHBSInstitutionName",
      featured: false,
    },
    { group: "HBS", label: "Clubs Region", id: "club", featured: false },
    {
      group: "HBS",
      label: "Volunteer/Committee",
      id: "HBSVolunteerRoleDisplay",
      featured: false,
    },
    {
      group: "Employment",
      label: "Company",
      id: "organizationName",
      featured: false,
    },
    {
      group: "Employment",
      label: "Function",
      id: "JobFunction",
      featured: false,
    },
    {
      group: "Employment",
      label: "Country",
      id: "officeCountrySorted",
      featured: false,
    },
    {
      group: "Employment",
      label: "State",
      id: "officeStateDesc",
      featured: false,
    },
    {
      group: "Employment",
      label: "Position",
      id: "positionLevel",
      featured: false,
    },
    {
      group: "Employment",
      label: "Military Service",
      id: "militaryService",
      featured: false,
    },
    { group: "Personal", label: "Gender", id: "genderLabel", featured: false },
    {
      group: "Personal",
      label: "Country of Origin",
      id: "countryOfOriginDesc",
      featured: false,
    },
    {
      group: "Personal",
      label: "Home State",
      id: "homeStateDesc",
      featured: false,
    },
    {
      group: "Personal",
      label: "Known Address",
      id: "knownAddress",
      featured: false,
    },
  ];

  const featuredFacets = facets
    .filter((facet) => facet.featured)
    .map((facet) => facet.id);
  const filters: Array<DirectorySearchFilterGroup> = [];

  facets.forEach((facet) => {
    // To be switched to /api/search/query with facet param?
    const { data } = useFetch<Array<Option>>({
      url: "/api/internal/alumni/facets",
      params: {
        index: "AlumniDirectory",
        facet: facet.id,
      },
    });

    if (data) {
      if (!filters.some((group) => group.label === facet.group)) {
        filters.push({
          label: facet.group,
          filters: [
            {
              label: facet.label,
              id: facet.id,
              options: data,
              selectedOptions: [],
              onChange: () => null,
            },
          ],
        });
      } else {
        const group = filters.find((group) => group.label === facet.group);
        if (group) {
          group.filters.push({
            label: facet.label,
            id: facet.id,
            options: data,
            selectedOptions: [],
            onChange: () => null,
          });
        }
      }
    }
  });

  const searchProps: DirectorySearchProps = {
    searchInputLabel: entry.fields.searchPlaceholder,
    searchQuery: "",
    onSearchQueryChange: () => null,
    filterGroups: filters,
    featuredFilterIds: featuredFacets,
    onSubmitSearch: () => null,
  };

  const props: DirectoryTopperProps = {
    title: entry.fields.title,
    theme: entry.fields.theme,
    search: searchProps,
  };

  return props;
});
